export function isPromise<T>(data: T | Promise<T>): data is Promise<T> {
  return (
    typeof data === 'object' &&
    data &&
    'then' in data &&
    typeof data.then === 'function' &&
    'catch' in data &&
    typeof data.catch === 'function'
  )
}
